export const TOAST_AUTO_DISMISS_MS = 4000;
